import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import CSSBuySpreadsheetPage from "@/pages/brand-cssbuy/page";
import SuperbuySpreadsheetPage from "@/pages/brand-superbuy/page";
import OopbuySpreadsheetPage from "@/pages/brand-oopbuy/page";
import MulebuySpreadsheetPage from "@/pages/brand-mulebuy/page";
import AllChinaBuySpreadsheetPage from "@/pages/brand-allchinabuy/page";
import JoyabuySpreadsheetPage from "@/pages/brand-joyabuy/page";
import SugargooSpreadsheetPage from "@/pages/brand-sugargoo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-sheet-przewodnik",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuySpreadsheetPage />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuySpreadsheetPage />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuySpreadsheetPage />,
  },
  {
    path: "/mulebuy-spreadsheet",
    element: <MulebuySpreadsheetPage />,
  },
  {
    path: "/allchinabuy-spreadsheet",
    element: <AllChinaBuySpreadsheetPage />,
  },
  {
    path: "/joyabuy-spreadsheet",
    element: <JoyabuySpreadsheetPage />,
  },
  {
    path: "/sugargoo-spreadsheet",
    element: <SugargooSpreadsheetPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;